import React, { useContext } from "react";
import { IntlContext } from "context";

interface Props {
    onShowProfile: () => void;
    onArchive: () => void;
    onBlockOrReport: () => void;
    isArchived?: boolean;
    showProfile?: boolean;
}

const Actions: React.FC<Props> = ({ onShowProfile, onArchive, onBlockOrReport, isArchived, showProfile = true }) => {
    const intl = useContext(IntlContext);

    const menuItemClass =
        "w-full text-left px-4 py-2.5 text-sm text-foreground hover:bg-secondary transition-colors first:rounded-t-lg last:rounded-b-lg";

    return (
        <div
            className="min-w-[220px] bg-white border border-border rounded-lg shadow-lg py-1"
            role="menu"
        >
            {showProfile && (
                <button type="button" className={menuItemClass} role="menuitem" onClick={onShowProfile}>
                    {intl.formatMessage("booking.messages.actions.show_profile")}
                </button>
            )}
            <button type="button" className={menuItemClass} role="menuitem" onClick={onArchive}>
                {intl.formatMessage(isArchived ? "booking.messages.actions.unarchive_discussion" : "booking.messages.actions.archive_discussion")}
            </button>
            <button type="button" className={menuItemClass} role="menuitem" onClick={onBlockOrReport}>
                {intl.formatMessage("booking.messages.actions.block_or_report")}
            </button>
        </div>
    );
};

export default Actions;
